import YouTube from "react-youtube";
import "./../styles/yt-popup-player.scss";
import { Modal } from "antd";

const playyerVars = {
    autoplay: 1,
    rel: 0,
    loop: 1,
    mute: 1,
    controls: 0,
    color: "white",
    modestbranding: 0,
    playsinline: 1,
    enablejsapi: 1,
    showinfo: 0,
    cc_load_policy: 3,
    iv_load_policy: 3
};

const YouTubePopupPlayer = ({
    youtubeId,
    title="",
    pausable = false,
    options = {},
    onClose = () => { }
}) => {
    const PLAYER_OPTIONS = {
        width: "100%",
        height: "100%",
        playerVars: { ...playyerVars, ...options, playlist: youtubeId }
    };

    return (
        <Modal
            className="yt-popup-player-modal"
            width={"50%"}
            visible={true}
            footer={null}
            onCancel={() => onClose(false)}
            maskClosable={true}
            title={title}
        >
            <div style={{ padding: 15 }}>
                <div className={`yt-popup-player ${pausable ? "pausable" : ""}`}>
                    <YouTube
                        videoId={PLAYER_OPTIONS.playerVars.playlist}
                        opts={PLAYER_OPTIONS}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default YouTubePopupPlayer;
